import React from 'react';
import { Award, Clock, CheckCircle, XCircle } from 'lucide-react';

const AchievementsListWidget = ({ achievements = [] }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 'verified': return <CheckCircle className="w-5 h-5 text-green-600" />;
      case 'rejected': return <XCircle className="w-5 h-5 text-red-600" />;
      default: return <Clock className="w-5 h-5 text-orange-600" />;
    }
  };

  return (
    <div className="space-y-3">
      {achievements.length === 0 ? (
        <div className="text-center py-8">
          <Award className="w-12 h-12 mx-auto mb-2 text-gray-300" />
          <p className="text-gray-500">No achievements yet</p>
        </div>
      ) : (
        achievements.map(ach => (
          <div key={ach.id} className="p-3 border rounded-lg">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h4 className="font-semibold text-gray-900">{ach.title}</h4>
                <p className="text-sm text-gray-600 mt-1">{ach.description}</p>
                <span className="inline-block mt-2 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">
                  {ach.category}
                </span>
              </div>
              {getStatusIcon(ach.status)}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default AchievementsListWidget;